import NotesCompose from 'global/NotesCompose';
import { ModalEditNoteWrapper } from './styled';

interface ModalEditNoteProps {
  visible: boolean;
  symbol: string;
  companyName: string;
  onClose: () => void;
}

const ModalEditNote = ({
  visible,
  symbol,
  companyName,
  onClose,
}: ModalEditNoteProps) => (
  <ModalEditNoteWrapper
    title={null}
    visible={visible}
    onCancel={onClose}
    width={658}
    centered
  >
    <NotesCompose
      defaultSymbol={symbol}
      companyName={companyName}
    />
  </ModalEditNoteWrapper>
);

export default ModalEditNote;
